<template>
  <div class="flex flex-col lg:flex-row justify-between items-center gap-8">
    <div class="flex flex-col items-center lg:flex-row gap-2.5 lg:gap-9 w-full lg:w-1/2">
      <BrandImageLink
        :brand="brand"
        size="medium"
      />
      <div class="text-EXPONDO-grey text-base leading-relaxed max-w-md">
        {{ $t(`about-brand-pdp-description.${brandKey}`) }}
      </div>
    </div>
    <div class="flex flex-col lg:flex-row gap-2.5 lg:gap-9 w-full lg:w-1/2">
      <CustomButton
        v-if="brand.url"
        type="secondary"
        :text="$t('visit-brand-page', {_brand_name_: brand.name})"
        :url="brand.url"
        class="lg:order-2"
        target="_blank"
      />
      <CustomButton
        type="primary"
        :text="$t('show-brand-products', {_brand_name_: brand.name})"
        :url="brandPage"
        class="lg:order-1"
      />
    </div>
  </div>
</template>

<script lang="ts">

import type { BrandInfo } from '~~/constants/brands';
import { getBrandKey } from '~~/helpers/brand';

export default defineComponent({
  name: 'AboutTheBrand',

  props: {
    brand: {
      type: Object as PropType<BrandInfo>,
      required: true,
    },
  },
  setup(props) {

    const { getBrandSearchPageUrl } = useBrandPage();
    const brandPage = computed(() => getBrandSearchPageUrl(props.brand));
    const brandKey = computed(() => getBrandKey(props.brand.name));

    return {
      brandPage,
      brandKey,
    };

  },
});

</script>
